import styled from 'styled-components';
import { CaptionRegularL, HeadingExtraBoldS } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';

export const RiskAnalysisSlideCont = styled.div`
  position: relative;
  display: flex;
  min-height: 20.5rem;
  align-items: center;
  justify-content: space-between;

  ${({ theme }: IThemeProvider) => `
    padding: ${theme.layout.spacing.decy} ${theme.layout.spacing.giga};
  `};
`;

export const RiskAnalysisCell = styled.div`
  position: relative;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RiskDiagramCell = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RiskDescriptionCont = styled.div`
  display: flex;
  max-width: 472px;
  flex-direction: column;
`;

export const RiskDescTitle = styled(HeadingExtraBoldS)`
  ${({ theme }: IThemeProvider) => `
    padding: 0 0 ${theme.layout.spacing.decy} 0;
  `};
`;

export const RiskDescription = styled(CaptionRegularL)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const LinkToReportCont = styled.a`
  position: relative;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  text-decoration: underline;

  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.centy} 0 0 0;
    color: ${theme.colors.support.blue[100]};
  `}
`;
